import { render } from "./chart-bar-naked.vue?vue&type=template&id=7b8f95ed"
import script from "./chart-bar-naked.vue?vue&type=script&lang=js"
export * from "./chart-bar-naked.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__